import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalIdParts } from '@lib/services';
import { PasswordInputHeaderComponent } from './password-input-header.component';
import { PasswordInputComponent } from './password-input.component';

/**
 * パスワード入力モーダルを開く際のパラメータ
 */
export function passwordInputPayloadParts(): ModalIdParts {
  return {
    id: 'passwordInputComponent',
    content: PasswordInputComponent,
    header: PasswordInputHeaderComponent,
    closeBackEnable: false,
    type: ModalType.TYPE1,
    modalWidth: LModalContentsWidthType.MODAL_TAB_W384,
  };
}
